import dayjs from "dayjs";
import { UpcomingRegistration } from "../../../../components/UpcomingRegistration/UpcomingRegistration";
import { isEventSoon } from "../../../../lib/useIsEventSoon";
import {
  daysUntilEvent,
  startsInEvening,
} from "../../../../lib/formatEventWhen";
import type { EventsWidgetProvider } from "./types";

/** The line under "Welcome, X!": when the viewer's event is. */
function subheadingFor(startsAt: string, now: number) {
  const d = dayjs(startsAt);
  const days = daysUntilEvent(startsAt, dayjs(now));
  const tonight = startsInEvening(startsAt);
  if (isEventSoon(startsAt, now)) {
    if (days === 0) return tonight ? "See you tonight!" : "See you today!";
    return "See you soon!";
  }
  if (days === 0) return tonight ? "You're going tonight" : "You're going today";
  if (days === 1) return "You're going tomorrow";
  if (days < 7) return `You're going on ${d.format("dddd")}`;
  return `You're going on ${d.format("MMM D")}`;
}

export const upcomingRegistrationProvider: EventsWidgetProvider = {
  id: "upcoming-registration",

  match({ sparks, now }) {
    const spark = sparks
      .filter((s) => s.registered && new Date(s.ends_at).getTime() > now)
      .sort(
        (a, b) =>
          new Date(a.starts_at).getTime() - new Date(b.starts_at).getTime()
      )[0];
    if (!spark) return null;

    return {
      key: `upcoming-registration-${spark.id}`,
      subheading: subheadingFor(spark.starts_at, now),
      render: () => <UpcomingRegistration spark={spark} />,
    };
  },
};
